import BackgroundVideo from "../assets/background.mp4";
import Logo from "../assets/logo.png";
import Banner from "../assets/banner.png";

const images = {
  BackgroundVideo,
  Logo,
  Banner,
};

export default images;
